import React from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import { CheckCircle2, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { INotification } from '../../services/NotificationService';

export const ToastContainer: React.FC = () => {
  const { notifications } = usePortfolio();

  if (notifications.length === 0) return null;

  const getIcon = (type: string) => {
    switch (type) {
      case 'success': return <CheckCircle2 size={18} color="var(--accent-green)" />;
      case 'error': return <AlertCircle size={18} color="#ff4d4d" />;
      case 'warning': return <AlertTriangle size={18} color="var(--accent-gold)" />;
      default: return <Info size={18} color="var(--accent-cyan)" />;
    }
  };

  return (
    <div style={{ position: 'fixed', bottom: '2rem', right: '2rem', zIndex: 1100, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
      {notifications.map((notif: INotification) => (
        <div key={notif.id} className="toast-notification show">
          {getIcon(notif.type)}
          <span style={{ fontSize: '0.9rem', fontWeight: 500 }}>{notif.message}</span>
        </div>
      ))}
    </div>
  );
};
